import { RootState } from "store/store";

export const selectRoles = (state: RootState) => state.roles;
export const selectRolesPage = (state: RootState) => state.roles.rolesPage;
